import React, { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import { api } from '../../api';

const statusLabels = {
  en_attente: 'En préparation',
  prete: 'Prête ! Venez récupérer',
  retiree: 'Retirée',
};

const statusStyles = {
  en_attente: 'bg-amber-50 text-amber-700 border border-amber-200',
  prete: 'bg-green-50 text-green-700 border border-green-200 animate-pulse',
  retiree: 'bg-gray-100 text-gray-500 border border-gray-200',
};

export default function OrderTracking() {
  const { orderId } = useParams();
  const [order, setOrder] = useState(null);

  useEffect(() => {
    const fetchOrder = () => api.getOrder(orderId).then(setOrder);
    fetchOrder();
    const interval = setInterval(fetchOrder, 5000);
    return () => clearInterval(interval);
  }, [orderId]);

  if (!order) return (
    <div className="flex items-center justify-center min-h-screen bg-[#FEFCF8]">
      <div className="animate-spin rounded-full h-8 w-8 border-2 border-[#C4673D] border-t-transparent" />
    </div>
  );

  // Grouper items par stand
  const stands = {};
  order.items.forEach(item => {
    const key = item.stand_nom || 'Autre';
    if (!stands[key]) stands[key] = [];
    stands[key].push(item);
  });

  return (
    <div className="min-h-screen bg-[#FEFCF8]">
      <header className="bg-white border-b border-[#F3DFC0] shadow-sm">
        <div className="max-w-lg mx-auto px-4 py-5 text-center">
          <h1 className="font-serif text-[#332A1C] font-bold text-xl">
            Commande #{order.id}
          </h1>
          <div className={`inline-block mt-3 px-4 py-1.5 rounded-full text-sm font-medium ${statusStyles[order.statut]}`}>
            {statusLabels[order.statut]}
          </div>
        </div>
      </header>

      <div className="max-w-lg mx-auto px-4 py-6 space-y-4">
        {order.statut === 'prete' && (
          <div className="bg-green-50 border-2 border-[#6B7F3B]/30 rounded-2xl p-6 text-center shadow-sm">
            <div className="flex items-center justify-center gap-2 mb-3">
              <span className="relative flex h-3 w-3">
                <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-[#6B7F3B] opacity-75"></span>
                <span className="relative inline-flex rounded-full h-3 w-3 bg-[#6B7F3B]"></span>
              </span>
            </div>
            <p className="text-[#6B7F3B] font-serif font-bold text-lg">
              Votre commande est prête !
            </p>
            <p className="text-[#8B7355] mt-2 text-sm">Rendez-vous au stand pour la récupérer</p>
          </div>
        )}

        {Object.entries(stands).map(([standName, items]) => (
          <div key={standName} className="bg-white rounded-2xl border border-[#F3DFC0] p-4 shadow-sm">
            <h2 className="font-serif text-[#332A1C] text-base font-semibold mb-3">{standName}</h2>
            {items.map(item => (
              <div key={item.id} className="flex justify-between py-2.5 border-b border-[#F3DFC0] last:border-0">
                <span className="text-[#8B7355]">{item.quantite}x {item.product_nom}</span>
                <span className="text-[#332A1C] font-medium">{(item.prix_unitaire * item.quantite).toFixed(2)} &euro;</span>
              </div>
            ))}
          </div>
        ))}

        <div className="bg-white rounded-2xl border border-[#F3DFC0] p-4 flex justify-between items-center shadow-sm">
          <span className="font-serif text-[#8B7355] text-base">Total</span>
          <span className="text-[#C4673D] font-bold text-xl font-serif">{order.total_ttc.toFixed(2)} &euro;</span>
        </div>

        {order.client && (
          <div className="bg-white rounded-2xl border border-[#F3DFC0] p-4 shadow-sm">
            <p className="text-sm text-[#8B7355]">
              Points de fidélité : <span className="font-semibold text-[#D97706]">{order.client.points_fidelite}</span>
            </p>
          </div>
        )}

        <Link to="/" className="block text-center text-[#8B7355] hover:text-[#332A1C] font-medium text-sm mt-6 transition">
          Retour à l'accueil
        </Link>
      </div>
    </div>
  );
}
